var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7h14a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V9a2 2 0 012-2zm7 10a4 4 0 100-8 4 4 0 000 8z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFF",
    opacity: 0.3,
    x: 9,
    y: 4,
    width: 6,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    opacity: 0.3,
    cx: 12,
    cy: 13,
    r: 2
  }))));
}
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAic3RhdGljL2Nzcy8yNjE2ZWZkZTBlMDRmMTZmZmJlMWFkNWM5MDg2NTJjNC5zdmciOw==";
export { SvgCamera as ReactComponent };